import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { UpliftType } from '@/graphql/contracts/_generated_/contracts';

import GetUpliftTypesQuery from '@/graphql/contracts/getUpliftTypes.query.gql';

import { GetUpliftTypes } from '@/graphql/contracts/_generated_/getUpliftTypes.query';

export function getUpliftTypes(): UpliftType[] {
  const result = apolloClientContracts.readQuery<GetUpliftTypes>({
    query: GetUpliftTypesQuery
  });

  return result?.upliftTypes as UpliftType[] || [];
}
